if(typeof AI == "undefined") { AI = {}; }

(function (AI) {
	'use strict';

	var streetView = function() {
		this.streetView = {};
	};

	streetView.prototype = {

        panorama: false,

		init: function() {

            var self = this;
            $(document).on("click", ".ai_street_view", function () {

                $('.property-streetmap-error').hide();
				var lat = $(this).data('lat');
				var lon = $(this).data('lon');
				var heading = $(this).data('heading');
                var pitch = $(this).data('pitch');
				var title = $(this).data('pname');

                setTimeout(function() {
                    self.loadStreetViewModal(title, lat, lon, heading, pitch);
                }, 700);
			});
		},

        loadStreetViewModal: function(title, lat, lon, heading, pitch) {

            // Set title
            $('#property-name').html(title);
            $('#property-streetmap-link').html('');

            // Load street view
            this.loadStreetView("property-streetview-pano", lat, lon, heading, pitch);

            // Set the href url
            $('#property-streetmap-link').html('View Larger Map').attr('href', this.getStaticUrl());
        },

        loadStreetView: function(elem_id, lat, lon, heading, pitch) {

            if (lat == 0 || lon == 0) {
                $('.property-streetmap-error').show();
                $('#'.elem_id).hide();
                return false;
            } else {
                $('.property-streetmap-error').hide();
                $('#'.elem_id).show();
            }

            heading = parseInt(heading);
            pitch = parseInt(pitch);

            if (this.panorama) {
                this.panorama.setPosition(new google.maps.LatLng(lat, lon));
                this.panorama.setPov({
                    heading: heading,
                    pitch: pitch
                });
            } else {

                var params = {
                    position: {lat: lat, lng: lon},
                    scrollwheel: false,
                    gestureHandling: 'cooperative',
                    pov: {
                        heading: (heading > 0) ? heading: 34,
                        pitch: (pitch > 0) ? pitch: 10
                    }
                };

                console.log(params);
                this.panorama = new google.maps.StreetViewPanorama(document.getElementById(elem_id), params);
            }
        },

        getStaticUrl: function() {
            var latlng = this.panorama.getPosition();
            var pov = this.panorama.getPov();

            var url = 'http://www.google.com/maps/place/'+encodeURIComponent(latlng.lat() + ", " + latlng.lng());
            console.log("img src: " + url);
            return url;
        }
	};

	AI.streetView = new streetView();

})(AI);

AI.streetView.init();


// WEBPACK FOOTER //
// ./resources/assets/js/ai/street-view.js